import { Container, Heading, Text, List, ListItem, Link, Box, VStack, Divider, Button, useColorModeValue } from '@chakra-ui/react';
import MainLayout from '../../components/layout/MainLayout';

const CookiePolicyPage: React.FC = () => {
  const textColor = useColorModeValue('gray.700', 'gray.300');
  const headingColor = useColorModeValue('gray.900', 'gray.100');
  const boxBg = useColorModeValue('blue.50', 'blue.900');
  const boxText = useColorModeValue('blue.900', 'blue.100');

  const openCookieSettings = () => {
    window.dispatchEvent(new Event('cookie-consent-open'));
  };

  return (
    <MainLayout>
      <Container maxW="3xl" py={8}>
        <VStack align="stretch" spacing={6}>
          <Heading as="h1" size="xl" mb={2} color={headingColor}>Pravidla používání souborů cookies</Heading>
          <Text fontSize="sm" color={textColor}>
            Poslední aktualizace: {new Date().toLocaleDateString('cs-CZ')}
          </Text>

          <Box bg={boxBg} p={4} borderRadius="md">
            <Text fontWeight="bold" mb={2} color={boxText}>Shrnutí</Text>
            <Text fontSize="sm" color={boxText}>
              Cookies používáme pro zajištění nezbytných funkcí webu, zlepšení uživatelského zážitku a měření návštěvnosti. Nepovinné cookies ukládáme pouze na základě vašeho souhlasu.
            </Text>
          </Box>

          <Divider />

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>1. Co jsou cookies?</Heading>
            <Text color={textColor} mb={4}>
              Cookies jsou malé textové soubory ukládané do vašeho zařízení při návštěvě webu. Umožňují rozpoznat prohlížeč, pamatovat si vaše volby a zajistit fungování webu.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>2. Jaké cookies používáme</Heading>
            <List spacing={2} mb={4} styleType="disc" pl={6} color={textColor}>
              <ListItem><strong>Nezbytné:</strong> zajišťují bezpečnost a základní funkce webu. Vždy aktivní.</ListItem>
              <ListItem><strong>Preferenční:</strong> pamatují si vaše volby (např. jazyk, zobrazení).</ListItem>
              <ListItem><strong>Analytické:</strong> anonymní měření návštěvnosti a výkonu stránek.</ListItem>
              <ListItem><strong>Marketingové:</strong> přizpůsobení obsahu a případného marketingu.</ListItem>
            </List>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>3. Právní základy a účely</Heading>
            <List spacing={2} mb={4} styleType="disc" pl={6} color={textColor}>
              <ListItem><strong>Nezbytné cookies:</strong> oprávněný zájem na provozu a zabezpečení webu (GDPR čl. 6 odst. 1 písm. f).</ListItem>
              <ListItem><strong>Preferenční, analytické, marketingové:</strong> pouze na základě vašeho souhlasu (GDPR čl. 6 odst. 1 písm. a), který můžete kdykoli odvolat.</ListItem>
            </List>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>4. Správa souhlasu</Heading>
            <Text color={textColor} mb={3}>
              Nastavení cookies můžete kdykoli změnit pomocí tlačítka níže nebo v nastavení prohlížeče. Odvolání souhlasu nemá vliv na zákonnost předchozího zpracování.
            </Text>
            <Button onClick={openCookieSettings} colorScheme="blue" size="sm">Otevřít nastavení cookies</Button>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>5. Doba uchovávání</Heading>
            <List spacing={2} mb={4} styleType="disc" pl={6} color={textColor}>
              <ListItem><strong>Nezbytné cookies:</strong> po dobu nezbytnou pro fungování relace či bezpečnost.</ListItem>
              <ListItem><strong>Preferenční a analytické:</strong> typicky 6–26 měsíců, nebo do odvolání souhlasu.</ListItem>
              <ListItem><strong>Marketingové:</strong> dle konkrétní kategorie, nejdéle do odvolání souhlasu.</ListItem>
            </List>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>6. Třetí strany</Heading>
            <Text color={textColor} mb={4}>
              Pro analytiku nebo měření můžeme využívat nástroje třetích stran. Tyto služby zpracovávají údaje pouze v rozsahu nezbytném pro poskytování měření a jsou vázány smluvními závazky ochrany údajů.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>7. Další informace</Heading>
            <Text color={textColor} mb={2}>
              Podrobnosti o zpracování osobních údajů najdete v <Link href="/zasady-ochrany-osobnich-udaju" color="brand.primary">Zásadách ochrany osobních údajů</Link>.
            </Text>
            <Text color={textColor}>
              V případě dotazů nás kontaktujte prostřednictvím stránky <Link href="/kontakt" color="brand.primary">Kontakt</Link>.
            </Text>
          </Box>
        </VStack>
      </Container>
    </MainLayout>
  );
};

export default CookiePolicyPage;
